import React from "react";
import Login_1 from "../Login/Login_1";
import Footer from "../Footer/Footer";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
const Login_open = () => {
  return (
    <>
      {" "}
      <NoZoomWrapper>
        <NoCopyWrapper>
          <Login_1 />
          <Footer />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default Login_open;
